import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { TableSelector } from "../../components/TableSelector/TableSelector";
import { useNavigate } from "react-router-dom";

export const WaiterDashboard = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ p: 3 }}>
            {/* Page Title */}
            <Typography variant="h5" gutterBottom fontWeight={600}>
                Select Your Table
            </Typography>

            {/* Table Selection Card */}
            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <TableSelector
                    onSelectTable={(table) => {
                        console.log("Selected table:", table);
                        navigate(`/pos/menu?tableId=${table.table_id}`);
                    }}
                />
            </Paper>
        </Box>
    );
};